import React from "react";

function BenefitDescription({ heading, description, fade }) {

  const dataAOS = `fade-${fade}`

  return (
    <div className="w-full md:w-1/2 p-4 md:p-0 md:pt-12" data-aos={dataAOS}>
      <h3 className="text-2xl md:text-3xl text-center md:text-justify font-bold tracking-wide leading-tight pb-6">
        {heading}
      </h3>      
      <p className="text-lg md:text-xl lg:text-2xl text-gray-700 max-w-lg">
        {description}
      </p>   
    </div>
  );
}

export default BenefitDescription;